import $DB from '../../util/debounce'
export default {
  data() {
    return {
      one: 0,
      two: 0,
      user: {
        mobile: '',
        code: '',
        password: '',
        pwd: '',
      },
      codeTxt: '获取验证码',
      sending: true,
      second: 60,
      disabled: false,
      phone: '',
      phoneTxt: '', //客服电话
    }
  },
  created() {
    this.getPhone()
  },
  methods: {
    //修改密码
    submit: $DB(function () {
      if (!this.user.password) {
        this.$message.error('请输入密码')
        return
      }
      if (this.user.pwd != this.user.password) {
        this.$message.error('两次输入的密码不一致')
        return
      }
      this.$axios.post('/api/login/forget_pwd', this.user).then((res) => {
        if (res.data.code === 0) {
          this.$message({
            message: res.data.msg,
            type: 'success',
          })
          setTimeout(() => {
            this.$router.push('/login')
          }, 800)
        } else {
          this.$message.error(res.data.msg)
        }
      })
    }),
    //去修改密码
    editPassword: $DB(function () {
      if (!this.user.code) {
        this.$message.error('请输入验证码')
        return
      }
      this.two = 1
    }),
    //去获取code
    goCode() {
      if (!this.user.mobile.match(/^(0|86|17951)?1[3456789]\d{9}$/)) {
        this.$message.error('请输入正确的手机号')
        return
      }
      this.one = 1
    },
    changeOne(type) {
      this.two = 0
      this.one = type
    },
    changeTwo() {
      // if (this.one!=1) return
      // this.one = 2
      this.two = 1
    },
    //获取验证码
    getCode: $DB(function () {
      if (!this.sending) return
      if (!this.user.mobile.match(/^(0|86|17951)?1[3456789]\d{9}$/)) {
        this.$message.error('请输入正确的手机号')
        return
      }
      this.$axios
        .post('/api/login/tel_code', {
          phone: this.user.mobile,
        })
        .then((res) => {
          this.sending = false
          this.disabled = true
          if (res.data.code == 0) {
            this.timeDown()
            var reg = /^(\d{3})\d{4}(\d{4})$/

            // var a = 18731230865;

            this.phone = this.user.mobile.replace(reg, '$1****$2')
          }
          this.$message({
            message: res.data.msg,
            type: 'success',
          })
        })
    }),
    timeDown() {
      let result = setInterval(() => {
        --this.second
        this.codeTxt = '已发送（' + this.second + 'S)'
        if (this.second < 0) {
          clearInterval(result)
          this.sending = true
          this.disabled = false
          this.second = 60
          this.codeTxt = '获取验证码'
        }
      }, 1000)
    },
    //获取平台带年华
    getPhone() {
      this.$axios.post('/api/index/contactUs').then((res) => {
        if (res.data.code === 0) {
          this.phoneTxt = res.data.data
        }
      })
    },
  },
}
